<h1>{{ lesseeId ? 'Editace pachtýře' : 'Založení pachtýře' }}</h1>

<div [loading]="loading">
  <div *ngIf="!loading">
    <div>
      <gmt-project-subject [subject]="lessee"></gmt-project-subject>
    </div>

    <div class="actions">
      <gmt-button *ngIf="lessee.id === undefined" [gmtDisabled]="!isValid()" [clickAction]="onCreate">Uložit</gmt-button>
      <gmt-button *ngIf="lessee.id !== undefined" [gmtDisabled]="!isValid()" [clickAction]="onUpdate">Uložit</gmt-button>
    </div>
  </div>
</div>
